import { cn } from "@/libs/cn";

interface Props extends React.HTMLProps<HTMLDivElement> {
    children: React.ReactNode;
    animationType?: "fade-in" | "slide-up";
}

export function AnimatedComponent({
    children,
    animationType = "slide-up",
    ...props
}: Props) {
    return (
        <div
            {...props}
            className={cn(props.className, {
                "animate-slide-up": animationType === "slide-up",
                "animate-fade-in": animationType === "fade-in",
            })}
        >
            {children}
        </div>
    )
}
